import { Component, viewChild } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import { HeaderComponent } from '../../../components/header/header.component'
import type { ViewType } from '../../../types/view-type.model'
import { EditorsListComponent } from './components/editors-list/editors-list.component'

@Component({
  selector: 'dhp-editors-overview',
  templateUrl: './editors-overview.component.html',
  styleUrls: ['./editors-overview.component.css'],
  imports: [HeaderComponent, EditorsListComponent, TranslatePipe],
})
export class EditorsOverviewComponent {
  readonly editorsList = viewChild.required(EditorsListComponent)
  viewType: ViewType = 'list'
  selectedMagazineIds: number[] = []

  onSearch(term: string): void {
    const editorsList = this.editorsList()
    if (editorsList) {
      editorsList.searchTerm = term
      editorsList.resetAndReload()
    }
  }

  onViewTypeChange(newViewType: ViewType): void {
    this.viewType = newViewType
  }

  get isGridView(): boolean {
    return this.viewType === 'grid'
  }

  onMagazinesChange(magazineIds: number[]): void {
    this.selectedMagazineIds = magazineIds
    // Add any additional logic needed for magazine filtering
  }
}
